export default __webpack_public_path__ + "c7.png";